import {Clone, CloneWithPrototypes, E, ModifyString} from "js-vextensions";
import React from "react";
import {Column, Row, Button, RowLR, Spinner, Text, TextInput} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {ErrorBoundary, GetUpdates, Observer, RunInAction_Set} from "web-vcore";
import {UpdateMapObject} from "../../../Server/Commands/MapObjectCommands.js";
import {GetMapObject} from "../../../Server/DB/mapObjects.js";
import {MapObject} from "../../../Server/DB/mapObjects/@MapObject.js";
import {DMap} from "../../../Server/DB/maps/@Map.js";
import {GetMapState} from "../../../Store/main/maps/$mapState.js";
import {MapState, PropertiesTab} from "../../../Store/main/maps/@MapState.js";
import {General_CompUI} from "./ObjectComps/General_CompUI.js";
import {Journal_CompUI} from "./ObjectComps/Journal_CompUI.js";
import {Visuals_CompUI} from "./ObjectComps/Visuals_CompUI.js";
import {observer_mgl} from "mobx-graphlink";
import {Meshes_CompUI} from "./ObjectComps/Meshes_CompUI.js";
import {ScrollView} from "react-vscrollview";
import {CloneSafe} from "../../../Utils/General/Serialization.js";
import {Paths_CompUI} from "./ObjectComps/Paths_CompUI.js";
import {Modifiers_CompUI} from "./ObjectComps/Modifiers_CompUI.js";

export type PropertiesUI_SharedProps = {
	map: DMap;
	mapState: MapState;
	obj: MapObject;
	Change: (objChanger: (obj: MapObject)=>any)=>void;
};

export const PropertiesUI = observer_mgl((props: {map: DMap, mapState: MapState})=>{
	const {map, mapState} = props;
	const uiState = mapState.propertiesPanel;

	const activeObject = GetMapObject.CatchBail("loading", mapState.activeObject, map.id);
	// if data loading, still show a panel (else it collapses and makes outliner take full height, messing up scroll-state)
	if (activeObject == "loading") {
		return (
			<Row style={{flex: 50, border: "solid rgba(0,0,0,1)", borderWidth: "3px 0 0 0"}}>
				<Text>Active object loading...</Text>
			</Row>
		);
	}

	return (
		<Row style={{flex: 1, border: "solid rgba(0,0,0,1)", borderWidth: "3px 0 0 0"}}>
			<Column>
				<PropertiesTabButton mapState={mapState} tab={PropertiesTab.general} icon="cube"/>
				<PropertiesTabButton mapState={mapState} tab={PropertiesTab.visuals} icon="shape"/>
				<PropertiesTabButton mapState={mapState} tab={PropertiesTab.meshes} icon="vector-triangle"/>
				<PropertiesTabButton mapState={mapState} tab={PropertiesTab.paths} icon="road-variant"/>
				<PropertiesTabButton mapState={mapState} tab={PropertiesTab.modifiers} icon="wrench"/>
				<PropertiesTabButton mapState={mapState} tab={PropertiesTab.journal} icon="notebook"/>
			</Column>
			<ScrollView ml={5} style={{flex: 1}}>
				{activeObject == null && <Column style={{flex: 50, border: "solid rgba(0,0,0,1)", borderWidth: "3px 0 0 0"}}>No active object.</Column>}
				{activeObject != null && (()=>{
					const Change = (objChanger: (obj: MapObject)=>any)=>{
						const newData = CloneSafe(activeObject);
						objChanger(newData);
						const updates = GetUpdates(activeObject, newData);
						new UpdateMapObject({id: activeObject.id, updates}).RunOnServer();
					};

					const sharedProps = {map, mapState, obj: activeObject, Change};
					return <ErrorBoundary key={uiState.tab}>
						{uiState.tab == PropertiesTab.general && <General_CompUI {...sharedProps}/>}
						{uiState.tab == PropertiesTab.visuals && <Visuals_CompUI {...sharedProps}/>}
						{uiState.tab == PropertiesTab.meshes && <Meshes_CompUI {...sharedProps}/>}
						{uiState.tab == PropertiesTab.paths && <Paths_CompUI {...sharedProps}/>}
						{uiState.tab == PropertiesTab.modifiers && <Modifiers_CompUI {...sharedProps}/>}
						{uiState.tab == PropertiesTab.journal && <Journal_CompUI {...sharedProps}/>}
					</ErrorBoundary>;
				})()}
			</ScrollView>
		</Row>
	);
});

const PropertiesTabButton = observer_mgl((props: {mapState: MapState, tab: PropertiesTab, icon: string})=>{
	const {mapState, tab, icon} = props;
	return (
		<Button mdIcon={icon} title={ModifyString(PropertiesTab[tab], m=>[m.startLower_to_upper])}
			style={E(
				{backgroundColor: "transparent", border: "none"},
				mapState.propertiesPanel.tab == tab && {backgroundColor: "rgba(48,48,48,1)"}
			)}
			onClick={()=>{
				RunInAction_Set(()=>mapState.propertiesPanel.tab = tab);
			}}/>
	);
});